module.exports = __webpack_public_path__ + "3e238197c01e15b5fbe3cd8213f31865.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/MP.svg
// module id = s5SW
// module chunks = 0